import { BaseItem } from 'components/dropdowns/SearchDropdown/itemRenderers/BaseItem'
import React, { ButtonHTMLAttributes } from 'react'
import { useNavigate } from 'react-router'
import { Model } from 'silta-ai-backend'
import styled from 'styled-components'
import { route } from 'utils/routes'

const Content = styled.div`
    min-width: 0;
`

interface ModelItemProps
    extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'value'> {
    value: Model
}

export function ModelItem({
    value,
    onClick: onClickProp,
    ...rest
}: ModelItemProps) {
    const navigate = useNavigate()

    return (
        <BaseItem
            {...rest}
            onClick={(e) => {
                onClickProp?.(e)

                navigate(route('model', value.id))
            }}
        >
            <Content>{value.name}</Content>
        </BaseItem>
    )
}
